












































































































































































































































import TitleBar from "@/components/Elements/TitleBar.vue";

import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { mapGetters, mapState, mapActions } from "vuex";

import { STORE_KEY, store } from "./_store";
import moment from "moment";
import XLSX from "xlsx";

@Component({
  computed: {
    ...mapGetters(STORE_KEY, ["total"]),
    ...mapState(STORE_KEY, [
      "loading",
      "loaded",
      "fatalError",

      "data",
      "documents",
      "meta"
    ])
  },
  methods: {
    ...mapActions(STORE_KEY, ["setReportOptions", "exportDataAsXLSX"])
  },
  components: {
    TitleBar
  }
})
export default class ExportToCrmReport extends Vue {
  get titleStack() {
    return ["Отчеты", "По выгрузке"];
  }

  localFilter: any = {
    view: "mes",
    employeeId: null,
    targetDates: [],
    planDates: [],
    finishDates: []
  };

  get defaultSort() {
    return [
      this.$route.query.sortField || "shift_date",
      this.$route.query.sortDirection || "asc"
    ];
  }

  onSort(field: string, direction: string) {
    console.log("onSort", field, direction);
    this.$router.replace({
      query: {
        ...this.$route.query,
        sortField: field,
        sortDirection: direction
      }
    });
  }

  public created() {
    // @ts-ignore
    if (!(STORE_KEY in this.$store._modules.root._children)) {
      this.$store.registerModule(STORE_KEY, store);
    }
  }
  clearDate(key: any) {
    this.localFilter[key] = [];
  }

  public mounted() {
    // @ts-ignore
    this.localFilter.view =
      this.$route.query && this.$route.query.view
        ? this.$route.query.view
        : "mes";
    // @ts-ignore
    this.localFilter.targetDates =
      this.$route.query && this.$route.query.targetDates
        ? [
            moment(this.$route.query.targetDates[0]).toDate(),
            moment(this.$route.query.targetDates[1]).toDate()
          ]
        : [];
    // @ts-ignore
    this.localFilter.planDates =
      this.$route.query && this.$route.query.planDates
        ? [
            moment(this.$route.query.planDates[0]).toDate(),
            moment(this.$route.query.planDates[1]).toDate()
          ]
        : [];
    // @ts-ignore
    this.localFilter.finishDates =
      this.$route.query && this.$route.query.finishDates
        ? [
            moment(this.$route.query.finishDates[0]).toDate(),
            moment(this.$route.query.finishDates[1]).toDate()
          ]
        : [];

    this.handleParamsChange();
  }

  setFilterData() {
    const query = Object.keys(this.localFilter).reduce((ac: any, key) => {
      switch (key) {
        case "targetDates":
          // @ts-ignore
          ac[key] = this.localFilter[key][0]
            ? [
                moment(this.localFilter[key][0]).format("YYYY-MM-DD"),
                moment(this.localFilter[key][1]).format("YYYY-MM-DD")
              ]
            : [];
          break;
        case "planDates":
          // @ts-ignore
          ac[key] = this.localFilter[key][0]
            ? [
                moment(this.localFilter[key][0]).format("YYYY-MM-DD HH:mm:ss"),
                moment(this.localFilter[key][1]).format("YYYY-MM-DD HH:mm:ss")
              ]
            : [];
          break;
        case "finishDates":
          // @ts-ignore
          ac[key] = this.localFilter[key][0]
            ? [
                moment(this.localFilter[key][0]).format("YYYY-MM-DD HH:mm:ss"),
                moment(this.localFilter[key][1]).format("YYYY-MM-DD HH:mm:ss")
              ]
            : [];
          break;
        default:
          // @ts-ignore
          ac[key] = this.localFilter[key];
      }
      return ac;
    }, {});

    this.$router.replace({
      query
    });
  }

  tableToExcel() {
    const csvContent: any[] = [];

    csvContent.push(...this.$store.getters[`${STORE_KEY}/exportData`]);
    const ws = XLSX.utils.aoa_to_sheet(csvContent);
    // @ts-ignore
    const range = XLSX.utils.decode_range(ws["!ref"]);
    if (!ws["!rows"]) ws["!rows"] = [];
    if (!ws["!cols"]) ws["!cols"] = [];
    const _col_width = {
      "0": 150,
      "2": 150
    };
    for (let R = range.s.r; R <= range.e.r; ++R) {
      // @ts-ignore
      if (!ws["!rows"][R]) {
        // @ts-ignore
        ws["!rows"][R] = { hpx: 20 };
      }

      for (let C = range.s.c; C <= range.e.c; ++C) {
        // @ts-ignore
        if (!ws["!cols"][C]) {
          // @ts-ignore
          ws["!cols"][C] = { wpx: _col_width[C] ? _col_width[C] : 75 };
        }
      }
    }
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Отчет");
    XLSX.writeFile(wb, "export.xlsx");
  }

  // ---------------------------------------------------------------------------

  @Watch("$route.query")
  public handleParamsChange() {
    this.$store.dispatch(`${STORE_KEY}/loadData`, this.$route.query);
  }
}
